import { render } from "./hot-picks.vue?vue&type=template&id=c0412dc2"
import script from "./hot-picks.vue?vue&type=script&lang=js"
export * from "./hot-picks.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__